<template>
    <div>
        <slot :entries="entries"></slot>
    </div>
</template>

<script>
export default {
    name: "entries",

    props: ["ids"],

    data() {
        return {
            entries: "Hallo Welt"
        };
    },

    created() {
        this.$entries(this.ids, entries => {
            this.entries = entries;
        });
    }
};
</script>


// WEBPACK FOOTER //
// src/components/Entries.vue